import type { FoxKifuAiAccountIdentity, FoxKifuAiStatusResponse } from '@wx-weiqi/contracts';

export interface AiAccountSelectionState {
  readonly aiSelection?: FoxKifuAiStatusResponse['data'] | null;
  readonly aiSelectedConfigurationId?: string | null;
}

export function accountLabel(account: FoxKifuAiAccountIdentity): string {
  // Stable ID suffix disambiguates accounts with the same masked phone/email.
  return `${account.accountLabel ? `${account.accountLabel} · ` : ''}${account.accountMasked} · ${account.configurationId.slice(-6)}`;
}

export function selectionFromStatus(
  state: AiAccountSelectionState,
  data: FoxKifuAiStatusResponse['data'],
) {
  const choices = data.accounts ?? [];
  const selected =
    choices.find((account) => account.configurationId === state.aiSelectedConfigurationId) ??
    choices.find((account) => account.configurationId === data.account?.configurationId);
  return {
    aiSelection: data,
    aiSelectedConfigurationId: selected?.configurationId ?? null,
    aiProfile: selected?.profile ?? data.profile,
  };
}

export function selectedAccount(state: AiAccountSelectionState) {
  return (
    state.aiSelection?.accounts?.find(
      (account) => account.configurationId === state.aiSelectedConfigurationId,
    ) ??
    state.aiSelection?.account ??
    null
  );
}
